module.exports = __webpack_public_path__ + "static/media/2-cats-and-a-dog.84eb9a9e.png";